var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EUIPrimaryLayout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('HeaderWidget')]},proxy:true},{key:"deault",fn:function(){return [_c('MenuDrawer')]},proxy:true},{key:"body",fn:function(){return [_c('router-view')]},proxy:true},{key:"footer",fn:function(){return [_c('InLifeFooterWidget')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }